import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  display: flex;
  flex-flow:column wrap;
  justify-content: center;
  background-color: ${colors.color1};
  min-height:120px;
  background-size: cover;
  background-position: center;
  @media (min-width: 992px) {
    min-height:200px;
  }
  .InsideHeader_title {
    margin: 0;
    font:900 24px/1.2 ${typography.SansSerif};
    color: white;
    text-align: center;
    padding:20px;
    text-transform: capitalize;
    @media (min-width: 768px) {
      font:900 36px/1.2 ${typography.SansSerif};
    }
    @media (min-width: 992px) {
      font:900 60px/1.2 ${typography.SansSerif};
    }
  }
`;

function InsideHeader({ h1, background }) {
  return (
    <div className={styles} style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.25) 0%,rgba(0,0,0,0.25) 100%), url(${buildThumbnailUrl(background, { width: 2000, height: 2000, preserve: true })})` }}>
      <div className="container">
        <h1 className="InsideHeader_title">{h1}</h1>
      </div>
    </div>
  );
}

InsideHeader.propTypes = {
  h1: PropTypes.node.isRequired,
  background: PropTypes.string,
};

InsideHeader.defaultProps = {
  h1: undefined,
  background: undefined,
};

export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js